// NavBar.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import style from './NavBar.module.css';
import refresh from '../../Assets/recargar.png'
import { useDispatch } from 'react-redux';
import { logout } from '../../Redux/Actions/actions';
import nuevoLogo from '../../Assets/nuevoLogo.png';
import NotificationDropdown from '../NotificationDropdown/NotificationDropdown';

const NavBar = () => {
  const handleRefresh = () => {
    window.location.reload(); // Recarga la página
  };
    const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(logout());
  };

  return (
    <div className={style.navbar}>
      <Link to="/home" className={style.title} >
      <img className={style.title} src={nuevoLogo} alt="" />
      </Link>
      <NotificationDropdown />
      <button className={style.refreshButton} onClick={handleRefresh}>
        <img className={style.icon} src={refresh} alt="" />
      </button>
         <button className={style.logoutButton} onClick={handleLogout}>
        Cerrar sesión
      </button>
      <Link to="/create" className={style.createButton}>
        CREAR NUEVA {/* Texto del botón */}
      </Link>
    </div>
  );
};

export default NavBar;
